export default __webpack_public_path__ + "media/images/pages/fitness-slide-2-5e35685a60bb4e9240c5f512b79093fd.jpg";